<img [src]="_imageUrl" class="logo-img" (click)="fileInput.click()"
    [class.is-invalid]="imageFormControl?.invalid"
>

<input hidden #fileUploadCtrl (change)="onSelectImage($event)" #fileInput type="file"
    accept="image/png,image/jpeg,image/svg+xml"
    [disabled]="isDisabled">